export { default } from './ImageAndTextMPCContainer';
